import React from 'react';
import PropTypes from 'prop-types';
import { TextareaStyled } from './TextArea.styled';

const Textarea = React.forwardRef(({
  name,
  modifiers,
  placeholder,
  ...props
}, ref) => (
  <TextareaStyled
    name={name}
    ref={ref}
    modifiers={modifiers}
    placeholder={placeholder}
    as="textarea"
    {...props}
  />
));

Textarea.propTypes = {
  modifiers: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
};

Textarea.defaultProps = {
  name: '',
  modifiers: '',
  placeholder: '',
};

export default Textarea;
